import React from "react"
import ReactHtmlParser from "react-html-parser"
import PropTypes from "prop-types"
import useProfileStore from "../profileStore"

export default function AccountPermissions({ labels, marketingConsentCurrent, marketingConsentLatest, parkingConsentCurrent, parkingConsentLatest }) {
  const {
    contactPermissionsHeading,
    labelContactPermissions,
    contactPermissionsText,
    labelParkingContactsPermissions,
    parkingContactPermissionsText,
  } = labels

  const {
    contactPermissionIsChecked,
    setContactPermissionIsChecked,
    parkingContactPermissionIsChecked,
    setParkingContactPermissionIsChecked,
    contactPermissionVersion,
    setContactPermissionVersion,
    parkingContactPermissionVersion,
    setParkingContactPermissionVersion,
  } = useProfileStore()

  const handleMarketingConsentChange = (checkbox) => {
    if (checkbox.checked) {
      setContactPermissionIsChecked(true)
      setContactPermissionVersion(marketingConsentLatest.ConsentVersion)
    } else {
      setContactPermissionIsChecked(false)
      setContactPermissionVersion("")
    }
  }

  const handleParkingConsentChange = (checkbox) => {
    if (checkbox.checked) {
      setParkingContactPermissionIsChecked(true)
      setParkingContactPermissionVersion(parkingConsentLatest.ConsentVersion)
    } else {
      setParkingContactPermissionIsChecked(false)
      setParkingContactPermissionVersion("")
    }
  }

  const marketingConsent = contactPermissionVersion === marketingConsentCurrent.ConsentVersion ? marketingConsentCurrent : marketingConsentLatest
  const parkingConsent = parkingContactPermissionVersion === parkingConsentCurrent.ConsentVersion ? parkingConsentCurrent : parkingConsentLatest

  return (
    <div className="form--profile__essentials">
      <div className="form__section form__section--no-border clearfix">
        <h3 className="profile-section-header">{contactPermissionsHeading}</h3>
        <div className="form__section__inner">
          <div className="form__field form__field--checkbox">
            <label className="form__label">
              <input
                className="form__item "
                id="NewsLetter"
                value="true"
                name="NewsLetter"
                onChange={(e) => {
                  handleMarketingConsentChange(e.target)
                }}
                type="checkbox"
                checked={contactPermissionIsChecked}
              ></input>
              <span className="form__label__text">
                <h4 className="profile-section-permissions-header">{marketingConsent.Header || labelContactPermissions}</h4>
                <span>{ReactHtmlParser(marketingConsent.Body || contactPermissionsText)}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div className="form__section form__section--no-border clearfix">
        <div className="form__section__inner">
          <div className="form__field form__field--checkbox">
            <label className="form__label">
              <input
                className="form__item "
                id="ParkingServicesPermission"
                value="true"
                name="ParkingServicesPermission"
                onChange={(e) => handleParkingConsentChange(e.target)}
                type="checkbox"
                checked={parkingContactPermissionIsChecked}
              ></input>
              <span className="form__label__text">
                <h4 className="profile-section-permissions-header">{parkingConsent.Header || labelParkingContactsPermissions}</h4>
                <span>{ReactHtmlParser(parkingConsent.Body || parkingContactPermissionsText)}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

AccountPermissions.propTypes = {
  labels: PropTypes.object.isRequired,
  marketingConsentCurrent: PropTypes.object.isRequired,
  marketingConsentLatest: PropTypes.object.isRequired,
  parkingConsentCurrent: PropTypes.object.isRequired,
  parkingConsentLatest: PropTypes.object.isRequired,
}
